import { createMutationGroup } from "../../core/api/mutations";
import { PatientDocumentScheduleId } from "../../shared/schema/schema";

export default createMutationGroup(({ createMutation, api }) => ({
  saveIcdCodes: (scheduledDocumentId: PatientDocumentScheduleId, htmlTemplateId: string) =>
    createMutation({
      mutationFn: () =>
        api.post(
          "./patient_documents/:scheduledDocumentId/templateId/:htmlTemplateId/save_icd_codes",
          {
            path: { scheduledDocumentId, htmlTemplateId },
            body: { noRelevantCodes: true },
          }
        ),
    }),
}));
